import React from 'react';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MdField from "core/metamodel/mdField";
import {action} from "mobx";
import styled from "styled-components";
import {grey500, indigo500} from "material-ui/styles/colors";
import {MouseEvent} from "react";

type MdTextFieldProps = {mdField?: MdField, numberFormat?: string, showValidationIcon?: boolean, validating?: boolean,
  onAction?: (evt: MouseEvent<HTMLAnchorElement>) => void, onActionEnable?: (value) => boolean, disabled?: boolean } & {[label:string]:any};

const ValidationWrapper = styled.div`
    display: flex;
    position:relative;
    width:100%;
`;

interface SpinnerSpanProps {
  validating: boolean;
  className: string;
}
const SpinnerSpan = styled.span`
    position: absolute;
    bottom: 18px;
    right: 0;
    color: ${grey500};
    display: ${ (props: SpinnerSpanProps) => props.validating ? 'inline' : 'none'};
`;

const ActionSpan = styled.span`
    position: absolute;
    bottom: 18px;
    right: 0;
    color: ${indigo500};
`;

const ActionAnchor = styled.a`
  cursor: pointer;
`;


export const MdTextField = ({mdField, numberFormat,showValidationIcon,validating,onAction,onActionEnable, ...other}: MdTextFieldProps) => {
  return (showValidationIcon) ? (
    <ValidationWrapper>
      <TextField {...other} />
      <SpinnerSpan className="fa fa-spin fa-spinner" validating={validating} />
      { (onAction && !validating && !other.errorText && onActionEnable(other.value) ) ? <ActionAnchor onClick={onAction}> <ActionSpan className="fa fa-clone"/> </ActionAnchor> : null}
    </ValidationWrapper>
  ) : (
    <TextField {...other} />
  );
};


type MdSelectFieldProps = {mdField?: MdField, numberFormat?: string, onChange?: Function} & {[label:string]:any};

export class MdSelectField extends React.PureComponent<MdSelectFieldProps, any> {

  @action onChange = (evt, index, value) => {
    this.props.onChange(value);
  };

  render() {
    let {mdField, numberFormat, onChange, ...other} = this.props;

    return (<SelectField onChange={this.onChange} {...other} />);
  }

}




type MdCheckboxProps = {mdField?: MdField, numberFormat?: string,
  fullWidth?: boolean, hintStyle?: any, errorStyle?: any, errorText?: string, floatingLabelStyle?: any, disabled?: boolean} & {[label:string]:any};


export const MdCheckbox = ({mdField, numberFormat,fullWidth, hintStyle, errorStyle, errorText, floatingLabelStyle,  ...other}: MdCheckboxProps) => (<Checkbox {...other}/>);



// WEBPACK FOOTER //
// ./src/core/components/fields/fields.tsx